module.exports = __webpack_public_path__ + "media/img/sbt-test/Scholarships2u-Student-Credibility-47de29c3312575e38b7262b86dd505bf.svg";